import { useState } from 'react'
import { ActivityIndicator } from 'react-native'

import {
  B2,
  BottomSheet,
  colors,
  H5,
  Icon,
  Pressable,
  SH3,
  Stack,
  XStack,
  YStack,
} from '@zet/design-system'
import { Alert } from '@zet/design-system/alert'
import { i18n } from '@zet/localization'

import { useGetCreditBureauExperiment } from '../../api/hooks/useGetCreditBureauExperiment'
import {
  CreditBureauExperimentName,
  CRIF_CREDIT_SCORE_RANGE,
  EXPERIAN_CREDIT_SCORE_RANGE,
} from '../../constants'
import VerifiedCustomersList from './VerifiedCustomersList'

export default function VerifiedCustomers({ navigation }) {
  const [isBottomSheetVisible, setIsBottomSheetVisible] =
    useState<boolean>(false)
  const { data, isLoading } = useGetCreditBureauExperiment(
    CreditBureauExperimentName.ExperianRollout
  )

  function showBottomSheet() {
    setIsBottomSheetVisible(true)
  }

  const creditRange = data?.ExperianRollout
    ? EXPERIAN_CREDIT_SCORE_RANGE
    : CRIF_CREDIT_SCORE_RANGE

  return (
    <Stack className="bg-grays-5 flex-1">
      <YStack className="flex-1">
        <Stack className=" bg-neutral-white100">
          <Pressable onPress={showBottomSheet}>
            <XStack className="bg-primary-10 mx-3 my-2.5 rounded-[4]">
              <Alert
                iconLeft={{
                  name: 'CreditScore',
                  color: colors.neutral.white100,
                }}
                iconRight={{
                  name: 'InfoOutlined',
                  color: colors.neutral.black100,
                }}
              >
                {i18n.t('myCustomers.creditScoreInfo')}
              </Alert>
            </XStack>
          </Pressable>
        </Stack>
        <VerifiedCustomersList navigation={navigation} />
      </YStack>
      <BottomSheet
        visible={isBottomSheetVisible}
        disableBottomSheet={() => setIsBottomSheetVisible(false)}
        onDismiss={() => setIsBottomSheetVisible(false)}
        sheetName="my_customers_credit_score"
      >
        {isLoading ? (
          <Stack
            style={{
              height: 500,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <ActivityIndicator size={'large'} />
          </Stack>
        ) : (
          <Stack>
            <H5 className="mt-4/2 mb-[20] self-center">
              {' '}
              {i18n.t('myCustomers.creditScoreInfo')}
            </H5>
            <XStack className="border-grays-30 p-4/2 items-center justify-between border-t-[1px]">
              <XStack className="items-center rounded-[3]  bg-[#D4FFE6] px-2">
                <Icon type={'CreditScoreExcellent'} size={20} className="" />
                <B2 className="ml-1 py-[6]">
                  {' '}
                  {i18n.t('myCustomers.excellent')}
                </B2>
              </XStack>
              <SH3>{creditRange.excellent}</SH3>
            </XStack>
            <XStack className="border-grays-30 p-4/2 items-center justify-between border-t-[1px]">
              <XStack className="items-center rounded-[3] bg-[#EAF3FF] px-2">
                <Icon type={'CreditScoreHigh'} size={20} className="" />
                <B2 className="ml-1 py-[6]">{i18n.t('myCustomers.high')}</B2>
              </XStack>
              <SH3>{creditRange.high}</SH3>
            </XStack>
            <XStack className="border-grays-30 p-4/2 items-center justify-between border-t-[1px]">
              <XStack className="items-center rounded-[3] bg-[#FFF5DE] px-2">
                <Icon type={'CreditScoreMedium'} size={20} className="" />
                <B2 className="ml-1 py-[6]">{i18n.t('myCustomers.medium')}</B2>
              </XStack>
              <SH3>{creditRange.medium}</SH3>
            </XStack>
            <XStack className="border-grays-30 p-4/2 items-center justify-between border-t-[1px]">
              <XStack className="items-center rounded-[3] bg-[#FFEAEA] px-2">
                <Icon type={'CreditScoreLow'} size={20} className="" />
                <B2 className="ml-1 py-[6]">{i18n.t('myCustomers.low')}</B2>
              </XStack>
              <SH3>{creditRange.low}</SH3>
            </XStack>
            <XStack className="border-grays-30 p-4/2 items-center justify-between border-t-[1px]">
              <Stack className="bg-grays-30 px-2 py-[6]">
                <B2>{i18n.t('myCustomers.newCredit')}</B2>
              </Stack>
              <SH3>{i18n.t('myCustomers.noCreditScore')}</SH3>
            </XStack>
            <XStack className="border-grays-30 p-4/2 items-center justify-between border-t-[1px]">
              <Stack className="bg-[#FFE6E0] px-2 py-[6]">
                <B2>{i18n.t('myCustomers.scoreExpired')}</B2>
              </Stack>
              <SH3>{i18n.t('myCustomers.needRecheck')}</SH3>
            </XStack>
          </Stack>
        )}
      </BottomSheet>
    </Stack>
  )
}
